// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"40419061","416":"4be203f4","467":"b538e73d"}[chunkId] + ".chunk.css";
};